<template>
  <div class="login-wrapper">

    <div class="login-box">
      <img src="../../assets/mImg/login_logo.png" alt="" class="login_logo">
      <div class="flex align-center justify-between login-top margin-bottom-sm">
        <h3>登录</h3>
        <p>社会组织评估填报系统</p>
      </div>

      <div class="flex align-center form-item">
        <van-icon name="contact" size="24" color="#368ad1"/>
        <van-field
          class="flex-sub"
          v-model="username"
          name="用户名"
          placeholder="请输入用户名"
          :rules="[{ required: true, message: '请填写用户名' }]"
        />
      </div>
      <div class="flex align-center form-item">
        <van-icon name="shield-o" size="24" color="#368ad1"/>
        <van-field
          class="flex-sub"
          v-model="code"
          type="number"
          name="验证码"
          placeholder="请输入验证码"
          :rules="[{ required: true, message: '请填写验证码' }]"
        >
          <template #button>
            <van-button size="small" type="info" @click.stop="sendCode">{{ codeText }}</van-button>
          </template>
        </van-field>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="onSubmit">提交</van-button>
      </div>

    </div>

  </div>
</template>

<script>
import {expertLogin, sendPhoneCode} from "@/api/login";

export default {
  name: "login",
  data() {
    return {
      username: '',
      code: '',

      codeText: '发送验证码', // 验证码文字
      timeId: null, // 一次性计时器id
    }
  },
  created() {
  },
  components: {},
  methods: {
    async onSubmit() {
      const reg = /^1[0-9]{10}$/;
      if (!this.username || !reg.test(this.username)) return this.$message.error('手机号有误，请确认')
      if (!this.code) return this.$message.error('验证码有误，请确认')
      const res = await expertLogin(this.username, this.code)
      if (res.status === 200) {
        this.$store.state.token = res.data.token
        this.$router.replace('/expert')
      }
    },
    async sendCode() {
      const reg = /^1[0-9]{10}$/;
      if (this.username && reg.test(this.username)) {
        if (this.codeText === '发送验证码' || this.codeText === '重新发送') {
          let time = 60
          let timer =  setInterval(() => {
            if (time === 0) {
              this.codeText = '重新发送'
              clearInterval(timer)
              return
            }
            time--
            this.codeText = time + '秒后重新发送'
          }, 1000)
          let _data = await sendPhoneCode(this.username, 1)
          if (_data.status !== 200) {
            this.codeText = '重新发送'
            clearInterval(timer)
          }
        }
      } else {
        this.$message.error('手机号有误，请确认')
      }
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.login-wrapper {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: url("../../assets/img/login_bg.png") no-repeat top center;
  background-size: 100% 100%;

  .login-box {
    width: calc(100vw - 40px);
    margin: 150px auto 0;
    padding: 100px 20px 20px;
    border-radius: 5px;
    background: #fff;
    position: relative;

    .login_logo {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: 50%;
    }

    .login-top {
      h3 {
        font-size: 22px;
      }

      p {
        font-size: 16px;
        color: #999;
        font-style: italic;
      }
    }

    .form-item {
      padding: 10px 0;
      border-bottom: 1px solid #f5f5f5;
    }
  }
}
</style>
